import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import {
  Container,
  Title,
  Card,
  Divider,
  TableContainer,
  Table,
  TableHeader,
  TableBody,
  MobileContainer,
  TrackingCard,
  CardRow,
  Label,
  Value,
} from "./style";
import RastreioPublicoService from "../../services/RastreioPublicoService";

export default function Rastreio() {
  let { uuid } = useParams();
  const [trackingData, setTrackingData] = useState([]);

  useEffect(() => {
    if (uuid) {
      new RastreioPublicoService()
        .tracking(uuid)
        .then((response) => {
          setTrackingData(response.data);
        })
        .catch((err) => {
          console.error(err);
          alert(
            "Erro ao buscar dados de rastreamento. Por favor, tente novamente mais tarde ou contate o suporte."
          );
        });
    }
  }, [uuid]);

  if (trackingData.length === 0) {
    return (
      <Container>
        <Card>
          <Title>Acompanhamento do frete</Title>
          <p>Não há dados disponiveis. Por favor, tente novamente mais tarde.</p>
        </Card>
      </Container>
    );
  }
  return (
    <Container>
      <Card>
        <Title>Acompanhamento do frete</Title>
        <Divider />

        {/* Versão Desktop - Tabela */}
        <TableContainer>
          <Table>
            <TableHeader>
              <tr>
                <th>Status da Transportadora</th>
                <th>Agência</th>
                <th>Data</th>
              </tr>
            </TableHeader>
            <TableBody>
              {trackingData.map((item) => (
                <tr key={item.uuid}>
                  <td>{item.statusFreteTransportadora}</td>
                  <td>{item.agencia}</td>
                  <td>{item.dataOcorrencia}</td>
                </tr>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Versão Mobile - Cards */}
        <MobileContainer>
          {trackingData.map((item) => (
            <TrackingCard key={item.uuid}>
              <CardRow>
                <div style={{ textAlign: "left" }}>
                  <Label>Status da Transportadora</Label>
                  <Value>{item.statusFreteTransportadora}</Value>
                </div>
                <div style={{ textAlign: "right" }}>
                  <Label>Agência</Label>
                  <Value align="right">{item.agencia}</Value>
                </div>
              </CardRow>
              <CardRow>
                <div style={{ textAlign: "left" }}>
                  <Label>Data</Label>
                  <Value>{item.dataOcorrencia}</Value>
                </div>
              </CardRow>
            </TrackingCard>
          ))}
        </MobileContainer>
      </Card>
    </Container>
  );
}
